import dynamic from 'next/dynamic'
const ReactSelect = dynamic(() => import('react-select'))

type Props = React.ComponentProps<typeof ReactSelect>
const ReactSelectDynamic = (props: Props) => <ReactSelect {...props} />

export default ReactSelectDynamic
